<template>
  <b-modal ref="modal" title="Vilogi Accounting Sync" centered no-close-on-backdrop no-close-on-esc hide-footer
    @hidden="$emit('closed')">
    <div v-if="session">
      <p class="mb-3">
        The bill email has been scheduled. Also post every eligible bill in this session to Vilogi now?
      </p>
      <p class="text-muted small mb-3">
        {{ session.site ? session.site.name : '' }}
        <span v-if="session.service_type"> &middot; {{ session.service_type.service_name }}</span>
      </p>
      <div v-if="blockedLots.length" class="alert alert-danger text-left">
        <p class="font-weight-bold mb-2">
          <i class="fas fa-exclamation-triangle mr-1"></i>
          {{ blockedLots.length }} lot(s) have invalid Vilogi account information. Please correct these in the Address Book.
        </p>
        <ul class="mb-0 pl-3 small">
          <li v-for="lot in blockedLots" :key="lot.archived_session_id">{{ lot.lot_no }}</li>
        </ul>
      </div>
      <div class="d-flex justify-content-end">
        <b-button variant="secondary" class="mr-2" :disabled="loading" @click="hide">Not now</b-button>
        <b-button variant="primary" :disabled="loading" @click="post">
          <b-spinner v-if="loading" small></b-spinner>
          <span v-else>Post to Vilogi</span>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ApiServices from '@/services/api'

export default {
  // Follow-up prompt shown after a bill email is scheduled, offering to also post the session to Vilogi.
  // Parent calls `$refs.x.show(sessionRow)`; emits `posted` after a successful trigger and `closed` whenever it hides.
  data() {
    return {
      session: null,
      loading: false,
      blockedLots: []
    }
  },
  methods: {
    // Opens the prompt for a closed-session row. 2026-10-20
    show(session) {
      this.session = session
      this.blockedLots = []
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    // Triggers the Vilogi batch for the session; keeps the prompt open and lists blocking lots if the backend rejects it. 2026-10-20
    post() {
      this.loading = true
      ApiServices.triggerVilogiBatch({ uuid: this.session.uuid })
        .then(response => {
          const result = (response && response.data) || {}
          this.SUCCESS_TOAST_MSG(`Queued ${result.queued || 0}, skipped ${result.skipped || 0}`)
          this.$emit('posted')
          this.hide()
        })
        .catch(err => {
          // Global interceptor already toasts the message; surface the blocking lots here.
          this.blockedLots = (err && err.data && err.data.non_compliant_lots) || []
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Common/vilogiPromptModal.vue